/** ========================================================================= *\
 * @prefab Floor
 * ========================================================================== */
import * as CONST from 'config';

class Floor extends Phaser.TileSprite {

  /** @constructor ---------------------------------------------------------- */
  constructor(game, x, y) {
    super(game, x, y, CONST.WORLD_LENGTH, CONST.FLOOR_HEIGHT, 'floor');
    this.anchor.set(0, 1);
  }

}

export default Floor;



// WEBPACK FOOTER //
// ./js/prefabs/floor.js